export const GOOGLE_API_KEY = "AIzaSyDIcV4cxIjjT23vdfiDKBQFKDczkuPTUPs";
export const CALENDAR_ID =
  "21j1cj1b2h7ank71t9lsc6msps@group.calendar.google.com";
export const SIGNUP_LINK = "https://forms.gle/6zbqvo3hc2YhqDCp9";
